import type { BaseRouteType, BaseMethodType } from '../types.ts'
import { z } from "zod";
export const tagsGetAdminMunicipalities_municipalityIdExternal_api = z.any()
export type TagsGetAdminMunicipalities_municipalityIdExternal_api = z.infer<typeof tagsGetAdminMunicipalities_municipalityIdExternal_api>

export const paramsGetAdminMunicipalities_municipalityIdExternal_api = z.object({ "municipalityId": z.string().uuid() })
export type ParamsGetAdminMunicipalities_municipalityIdExternal_api = z.infer<typeof paramsGetAdminMunicipalities_municipalityIdExternal_api>

export const responseGetAdminMunicipalities_municipalityIdExternal_api = z.object({ "payload": z.array(z.object({ "id": z.string(), "providerName": z.string(), "clientId": z.string(), "apiKey": z.string().max(4), "createdAt": z.string().datetime({ offset: true }), "updatedAt": z.string().datetime({ offset: true }), "collectionPointIds": z.array(z.string()), "collectionPoints": z.array(z.object({ "id": z.string(), "name": z.string(), "identifier": z.string(), "type": z.string(), "buildingId": z.string(), "buildingName": z.string() })) })).optional(), "errors": z.any(), "message": z.string().optional() })
export type ResponseGetAdminMunicipalities_municipalityIdExternal_api = z.infer<typeof responseGetAdminMunicipalities_municipalityIdExternal_api>

interface IGetAdminMunicipalities_municipalityIdExternal_api extends BaseMethodType {
  tags: TagsGetAdminMunicipalities_municipalityIdExternal_api,
  params: ParamsGetAdminMunicipalities_municipalityIdExternal_api,
  response: ResponseGetAdminMunicipalities_municipalityIdExternal_api
}
export const URL = '/admin/municipalities/:municipalityId/external-api'
export const validation = {
  get: {
    tags: tagsGetAdminMunicipalities_municipalityIdExternal_api,
    params: paramsGetAdminMunicipalities_municipalityIdExternal_api,
    response: responseGetAdminMunicipalities_municipalityIdExternal_api
  }
}
export interface AdminMunicipalities_municipalityIdExternal_api extends BaseRouteType {
  get: IGetAdminMunicipalities_municipalityIdExternal_api
}